module.exports = __webpack_public_path__ + "static/media/video-bg.b5ebf38d.jpg";